/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestResponseIcons interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestResponseIcons(value) {
    if (!('Src' in value) || value['Src'] === undefined)
        return false;
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    if (!('Sizes' in value) || value['Sizes'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayManifestResponseIconsFromJSON(json) {
    return FxIdWebFeaturesPlayManifestResponseIconsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestResponseIconsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Src': json['src'],
        'Type': json['type'],
        'Sizes': json['sizes'],
        'Purpose': json['purpose'] == null ? undefined : json['purpose'],
    };
}
export function FxIdWebFeaturesPlayManifestResponseIconsToJSON(json) {
    return FxIdWebFeaturesPlayManifestResponseIconsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestResponseIconsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'src': value['Src'],
        'type': value['Type'],
        'sizes': value['Sizes'],
        'purpose': value['Purpose'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayManifestResponseIcons.js.map